export default __webpack_public_path__ + "static/media/Upload_4.41c6fa4d.png";